import View from "../framework/view";
import template from "../../pugc/sessions";
import {Session} from "../bo/session";
import Server from "../server";
import {renderTimeInterval} from "../misc/utils";
import {format} from "date-fns";
import { UAParser } from "ua-parser-js";
import PlainObject = JQuery.PlainObject;
import {AppFunction, badgeChange, FunctionBadge} from "../misc/types";
import {BadgeNotification} from "./wrb";

const classname = "sessions-view";

const server = Server.instance();

export class SessionsView extends View {

    private fn: AppFunction;

    private sessions : Session[] = [];

    private runtimeParams : PlainObject = {};

    private from: Date = new Date();
    private to: Date = new Date();

    private refreshTimout: any;

    constructor(fn: AppFunction) {
        super(classname);
        this.fn = fn;
        this.init();
    }

    async init() {
        this.sessions = await server.sessions(this.from, this.to);
        this.runtimeParams = await server.getRuntimeParams();
        this.update();
    }

    queueRefresh() {
        this.refreshTimout && clearTimeout(this.refreshTimout);
        this.refreshTimout = setTimeout(() => { this.refresh() }, 60 * 1000);
    }

    render0() {

        const formatTimestamp = (ts: number) => {
            const d = new Date(ts);
            return format(d, "dd/MM/yyyy HH:mm:ss")
        };

        const now = Date.now();

        const activeSession = (s: Session) => {
            if (s.tsEnd === undefined) {
                return false;
            }
            const diff = now - s.tsEnd;
            return s.tsEnd && diff < 60 * 1000;
        };

        const formatUserAgent = (userAgent: string) => {
            const parser = new UAParser(userAgent);
            const device = parser.getDevice();
            const result = parser.getResult();
            const browser = parser.getBrowser();

            const out = [
                browser.toString(),
                result.os.toString(),
                device.toString()
            ].filter(x => x && x !== "undefined").join(" ");

            return out;
        }

        const renderSource = (session: Session) => {
            const search = session.search;
            let referer = session.referer;

            if (search) {
                const params = new URLSearchParams(`?${search}`);
                const gad_campaignid = params.get("gad_campaignid");
                if (gad_campaignid) {
                    const campaign = this.runtimeParams[`wrb.client.gad_campaignid.${gad_campaignid}`] || gad_campaignid;
                    return `Ad: ${campaign}`;
                }
                const srsltid = params.get("srsltid");
                if (srsltid) {
                    return "Google Shopping";
                }
            }
            if (referer) {
                if (referer == "https://www.google.com/") {
                    return "Google Search";
                }
                if (referer.length > 40) {
                    referer = referer.replace(/\?.+$/, "?[params...]");
                }

                return referer;
            }
        }

        const data = {
            sessions: this.sessions,
            renderTimeInterval: renderTimeInterval,
            formatTimestamp: formatTimestamp,
            formatUserAgent: formatUserAgent,
            renderSource: renderSource,
            active: activeSession,
        };

        const out = this.pug(template, data);

        this.queueRefresh();

        const b = {
            fn: this.fn,
            count: this.sessions.filter(activeSession).length,
            attention: 0,
        };

        return out;
    }

    public async refresh() {
        const onscreen = this.elt().length > 0;
        if (onscreen) {
            // On screen ...
            await this.init();
            server.clearCache();
        }
    }

}

View.on(
    "." + classname,
    "click",
    ".sync",
    function(that: SessionsView, event, elt) {
        event.preventDefault();
        event.stopImmediatePropagation();
        that.refresh();
    });

